import React, {Component} from 'react'
import {
    MDBContainer,
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBInputGroup,
    MDBAlert,
    MDBListGroup, MDBBadge
} from 'mdbreact';
import firebase from "../../Config/firebase";
import classes from './ViewPost.module.css'
import parse from 'html-react-parser'
import {Link, withRouter} from 'react-router-dom'

import ListReviewBox from '../ListReviewsBox/ListReviewBox'
import {
    faArrowLeft,
    faBookmark,
    faThumbsDown,
    faThumbsUp,
    faUser,
    faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {connect} from "react-redux";

import ReactQuillDisplayCss from "../../Utils/ReactQuillDisplay.module.css";
import {getFirebaseCustomClaim, isAuth} from "../../Utils/firebaseUtils";
import Select from "react-select";
import PollDisplay from "../Poll/PollDisplay";
import ShareContainer from "../../Component/ShareContainer/ShareContainer";


const db = firebase.firestore()

class ViewPost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            post: {},
            isLoaded: false,
            isMyCollection: false,
            Review: {
                FeatureImage: '',
                content: '',
                createDate: new Date(),
                createUserID: this.props.auth.uid,
                isPublish: true,
                createUserName: '',
                numOfReview: 0,
                lastModified: new Date(),
                numOfDisLike: 0,
                numOfLike: 0,
                isEdit: false,
            },
            Reviews: [],
            Replies: [],
            hasReply: false,
            isLoadedUserName: false,
            isEmpty: false,
            isReactedLike: false,
            isReacted: false
        }
    }

    componentDidMount() {
        if (typeof this.props.location.state !== "undefined") {
            if (this.props.location.state.hasOwnProperty('post')) {
                this.setState({
                    post: this.props.location.state.post
                }, () => {

                    this.getReviewByID(this.props.location.state.post.id)
                    this.setState({
                        isLoaded: true
                    })
                })
                // console.log(this.state.Replies)
            }
        } else {
            this.getPostByID(this.props.match.params.id)
            this.getReviewByID(this.props.match.params.id)
        }

        if (isAuth(this.props.auth)) {
            console.log(this.props)
            this.getLikeInfo(this.props.match.params.id, this.props.auth.uid)
            this.getCustomClaim(this.props.auth)
            this.getIsMyCollectionByID(this.props.match.params.id, this.props.auth.uid)
        }
    }

    timeStampToString = (ts) => {
        const date = new Date(ts * 1000)
        return date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()
    }

    getIsMyCollectionByID = async (pid, uid) => {
        db.collection('Member')
            .doc(uid)
            .collection('MyCollection')
            .where('postID', '==', pid)
            .get()
            .then(docs => {
                if (!docs.empty) {
                    this.setState({
                        isMyCollection: true
                    })
                }
            })
    }

    getPostByID = (pid) => {
        db.collection('Post')
            .doc(pid)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        post: doc.data()
                    }, () => {
                        this.setState({
                            isLoaded: true
                        })
                    })
                } else {
                    this.props.history.push({pathname: '/'})
                }
            })
    }

    getReviewByID = (aid) => {
        db.collection('Post').doc(aid).collection("Review")
            .orderBy('createDate', 'asc')
            .get()
            .then(docs => {
                if (!docs.empty) {
                    console.log("yes")
                    let allReview = []
                    docs.forEach(function (doc) {
                        const Review = {
                            id: doc.id,
                            ...doc.data()
                        }
                        console.log(Review)
                        allReview.push(Review)
                    })

                    this.setState({
                        Reviews: allReview
                    })
                } else {
                    console.log("null")
                }
            })
    }


    onReviewBox = (val) => {
        this.setState({
            Review: {
                ...this.state.Review,
                content: val
            }
        })
        console.log(this.state.Review)
    }

    addReview = () => {
        const Review = this.state.Review
        if (Review.content !== '') {
            db.collection("Post").doc(this.state.post.id).collection("Review")
                .add(Review).then(doc => {
                const newReview = {
                    id: doc.id,
                    content: Review.content,
                    createUserName: Review.createUserName
                }
                this.setState({
                    Reviews: this.state.Reviews.concat(newReview),
                    Review: {
                        FeatureImage: '',
                        content: '',
                        createDate: new Date(),
                        createUserID: this.props.auth.uid,
                        createUserName: newReview.createUserName,
                        numOfReview: 0,
                        isPublish: true,
                        lastModified: new Date(),
                        numOfDisLike: 0,
                        numOfLike: 0,
                        isEdit: false,
                    }
                })

            })

            db.collection("Post").doc(this.state.post.id).update({
                numOfReview: firebase.firestore.FieldValue.increment(1),
                lastReviewDate: new Date()
            })
        } else {
            this.setState({
                isEmpty: true
            })
        }
    }

    delReview = (val) => {
        let newReviews = this.state.Reviews.filter(word => word.id !== val)
        this.setState({
            isLoaded: false
        }, () => {
            this.setState({
                Reviews: newReviews
            }, () => {
                this.setState({
                    isLoaded: true
                })
            })
        })

        db.collection("Post").doc(this.state.post.id).update({
            numOfReview: firebase.firestore.FieldValue.increment(-1),
        })
    }

    getCustomClaim = async (auth) => {
        const getState = await getFirebaseCustomClaim(auth)
        if (getState.success) {
            let newUserName = []
            if (Array.isArray(getState.userName)) {
                getState.userName.map(name => {
                    console.log(name)
                    newUserName.push({
                        value: decodeURIComponent(escape(name.value)),
                        label: decodeURIComponent(escape(name.label))
                    })
                })
            }

            this.setState({
                userName: newUserName,
                Review: {
                    ...this.state.Review,
                    createUserName: newUserName[0].value
                }
            }, () => {
                this.setState({
                    isLoadedUserName: true
                })
            })
        }
    }

    onChangeReviewUserName = (userName) => {
        this.setState({
            Review: {
                ...this.state.Review,
                createUserName: userName
            }
        })
    }

    changeMyCollection = () => {
        const newCollection = {
            createDate: new Date(),
            postID: this.state.post.id,
            isPinned: false
        }
        if (this.state.isMyCollection === false) {
            db.collection("Member").doc(this.props.auth.uid).collection("MyCollection")
                .add(newCollection).then(doc => {

            })
            this.setState({
                isMyCollection: true
            })
        } else {
            db.collection("Member").doc(this.props.auth.uid).collection("MyCollection")
                .where('postID', '==', this.state.post.id).get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    doc.ref.delete()
                })
            })
            this.setState({
                isMyCollection: false
            })
        }
    }

    clickLike = () => {
        db.collection("Post")
            .doc(this.state.post.id)
            .update({
                likeCount: firebase.firestore.FieldValue.increment(1),
            })
            .then()
            .catch(err => console.log(err))
        db.collection("Post")
            .doc(this.state.post.id)
            .collection('Reaction')
            .doc(this.props.auth.uid)
            .set({
                isLike: true
            })
            .then()
            .catch(err => console.log(err))

        let likeCount = this.state.post.likeCount >= 0 ? this.state.post.likeCount + 1 : 1
        this.setState({
            isReactedLike: true,
            isReacted: true,
            post: {
                ...this.state.post,
                likeCount: likeCount
            }
        })
    }

    clickDisLike = () => {
        db.collection("Post")
            .doc(this.state.post.id)
            .update({
                dislikeCount: firebase.firestore.FieldValue.increment(1),
            })
            .then()
            .catch(err => console.log(err))

        db.collection("Post")
            .doc(this.state.post.id)
            .collection('Reaction')
            .doc(this.props.auth.uid)
            .set({
                isLike: false
            })
            .then()
            .catch(err => console.log(err))

        let dislikeCount = this.state.post.dislikeCount >= 0 ? this.state.post.dislikeCount + 1 : 1
        this.setState({
            isReactedLike: false,
            isReacted: true,
            post: {
                ...this.state.post,
                dislikeCount: dislikeCount
            }
        })
    }

    getLikeInfo = (postID, uid) => {
        db.collection('Post')
            .doc(postID)
            .collection('Reaction')
            .doc(uid)
            .get()
            .then(doc => {
                if (doc.exists) {
                    this.setState({
                        isReactedLike: doc.data().isLike,
                        isReacted: true
                    })
                }
            })
    }

    render() {
        if (this.state.isLoaded) {
            return (
                <MDBContainer>
                    <MDBRow>
                        <MDBCol xl="9" lg="9" md='8' sm='12'>
                            <MDBCard className={classes.PostCard}>
                                {/*<MDBCardImage className="img-fluid" src="https://mdbootstrap.com/img/Mockups/Lightbox/Thumbnail/img%20(67).jpg"*/}
                                {/*              waves />*/}
                                <MDBCardBody className={classes.CardBody}>
                                    <MDBBtn color='link'
                                            className={classes.BookMarkBtn}
                                            onClick={ () => {
                                                if(isAuth(this.props.auth)){
                                                    this.changeMyCollection()
                                                }
                                                else{
                                                    this.props.history.push({pathname: '/login'})
                                                }
                                            }}
                                    >
                                        {
                                            this.state.isMyCollection ?
                                            <FontAwesomeIcon icon={faBookmark} className={classes.BookMarkOn}/>
                                            :
                                            <FontAwesomeIcon icon={faBookmark} className={classes.BookMarkOff}/>
                                        }
                                    </MDBBtn>
                                    <div className={classes.PostContent}>
                                        <div className={classes.CardHeading}>
                                            <FontAwesomeIcon icon={faUserCircle} className={classes.CardIcon}/>
                                            <div className={classes.PostMetadata}>
                                                {
                                                    this.state.post.hasOwnProperty('createUserName') ?
                                                        this.state.post.createUserName
                                                        : ''
                                                }
                                                <br/>
                                                <span>
                                                    {this.timeStampToString(this.state.post.lastModified.seconds)}
                                                </span>
                                            </div>
                                        </div>
                                        <div className={classes.PostMain}>
                                            <h1 className={classes.Title}>
                                                {this.state.post.title}
                                            </h1>

                                            <div className={classes.Content}>
                                                <main className={ReactQuillDisplayCss.ReactQuillDisplay}>
                                                    {parse(this.state.post.content)}
                                                </main>
                                            </div>

                                        </div>


                                        <div className={classes.PostAction}>
                                            <button className={classes.likeButton}
                                                    disabled={this.state.isReacted}
                                                    onClick={(e) => {
                                                        if(isAuth(this.props.auth)){
                                                            this.clickLike()
                                                        }
                                                        else{
                                                            this.props.history.push({pathname: '/login'})
                                                        }
                                                    }}
                                            >
                                                <FontAwesomeIcon icon={faThumbsUp}
                                                                 className={this.state.isReacted && this.state.isReactedLike ? classes.ThumbsUpGreen : classes.ThumbsUp}/>
                                            </button>
                                            {this.state.post.likeCount}
                                            <button className={classes.likeButton}
                                                    disabled={this.state.isReacted}
                                                    onClick={(e) => {
                                                        if(isAuth(this.props.auth)){
                                                            this.clickDisLike()
                                                        }
                                                        else{
                                                            this.props.history.push({pathname: '/login'})
                                                        }
                                                    }}
                                            >
                                                <FontAwesomeIcon icon={faThumbsDown}
                                                                 className={this.state.isReacted && !this.state.isReactedLike ? classes.ThumbsDownRed : classes.ThumbsDown}/>
                                            </button>
                                            {this.state.post.dislikeCount}
                                        </div>

                                        <div className={classes.ShareContainer}>
                                            <ShareContainer
                                                url={'https://tmingler.com/post/' + this.props.match.params.id}
                                                img={''}
                                                title={this.state.post.title}
                                                content={this.state.post.content}
                                                tags={this.state.post.hasOwnProperty('tags') ? this.state.post.tags : []}
                                            />
                                        </div>
                                    </div>
                                    <hr/>

                                    {this.state.post.isPoll ?
                                        <PollDisplay
                                            auth={this.props.auth}
                                            postID={this.props.match.params.id}
                                            pollTitle={this.state.post.pollTitle}
                                            numberOfVotes={this.state.post.numberOfVotes}/>
                                        : ''}

                                    <hr/>
                                    {
                                        this.props.auth.isEmpty ?
                                            ''
                                            : <div className={classes.NewCommentCard}>
                                                <h2 className={classes.CommentHeading}>
                                                    新增回應 <MDBBadge color='primary'><Link to={'/m/profile'}>新增網名</Link>
                                                </MDBBadge>
                                                </h2>

                                                {
                                                    this.state.isEmpty ?
                                                        <MDBAlert color='danger'>
                                                            請填寫回應內容
                                                        </MDBAlert>
                                                        : ''
                                                }

                                                <div className={classes.AddReplyContainer}>
                                                    <div className={classes.ReplyGrid}>
                                                        <div>
                                                            <span>選擇你的身份</span>
                                                            {
                                                                this.state.isLoadedUserName ?
                                                                    <Select options={this.state.userName}
                                                                            className={classes.Select}
                                                                            value={{
                                                                                label: this.state.Review.createUserName,
                                                                                value: this.state.Review.createUserName
                                                                            }}
                                                                            onChange={(e) => this.onChangeReviewUserName(e.value)}/>
                                                                    : 'loading'
                                                            }
                                                        </div>
                                                        <div>
                                                            <span>回應內容</span>
                                                            <input
                                                                type={'textarea'}
                                                                className="form-control"
                                                                value={this.state.Review.content}
                                                                onChange={(e) => {
                                                                    this.onReviewBox(e.target.value)
                                                                    this.setState({
                                                                        isEmpty: false
                                                                    })
                                                                }}
                                                            />
                                                        </div>
                                                        <div>
                                                            <MDBBtn color='primary'
                                                                    className={classes.SubmitCommentBtn}
                                                                    onClick={(e) => this.addReview()}>
                                                                發送
                                                            </MDBBtn>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    }
                                    <hr/>
                                    <div className={classes.ListCommentContainer}>

                                        {
                                            this.state.isLoaded ?
                                                <div>
                                                    <h2 className={classes.CommentHeading}>
                                                        回應
                                                    </h2>
                                                    {
                                                        this.state.Reviews.length !== 0 ?
                                                            <MDBListGroup>
                                                                {
                                                                    this.state.Reviews.map((Review, index) => {
                                                                            return (
                                                                                <ListReviewBox
                                                                                    key={index}
                                                                                    index={index + 1}
                                                                                    data={Review}
                                                                                    postID={this.state.post.id}
                                                                                    auth={this.props.auth}
                                                                                    userName={this.state.isLoadedUserName ? this.state.userName : []}
                                                                                    delReview={this.delReview}
                                                                                />

                                                                            )
                                                                        }
                                                                    )}
                                                            </MDBListGroup>
                                                            :
                                                            <div>
                                                                未有回應
                                                            </div>
                                                    }

                                                </div>

                                                : ''
                                        }
                                    </div>


                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>

                        <MDBCol xl="3" lg="3" md='4' sm='0'>
                            <MDBCard className={classes.PostCard}>
                                <MDBCardBody>
                                    ADS
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    </MDBRow>


                </MDBContainer>
            )
        } else {
            return (
                <div>
                    loading
                </div>
            )
        }
    }
}


const enhance = connect(
    ({firebase: {auth, profile}}) => ({
        auth,
        profile
    })
)

export default enhance(withRouter(ViewPost))
